import { Injectable } from '@angular/core';
import { CookieService } from 'ngx-cookie-service';
import { ContractedFeatureFilterDto } from '../models/dto/contracted-feature-filter.dto';
import { IntegrationFilterDto } from '../models/dto/integration-filter.dto';
import { ContractedFeatureService } from './contracted-feature.service';
import { IntegrationService } from './integration.service';
import { UsersService } from './user.service';
import { UserPreferencesService } from './user-preferences.service';
import { UserUtil } from '../utils/user.utils';
import { ContractedFeatureUtil } from '../utils/contracted-feature.utils';
import { ActivesoftIntegrationUtil } from '../utils/activesoft-integration.utils';
import { AuthUtil } from '../utils/auth.utils';
import { AuthIdentityResponse } from '../models/interfaces/auth-response.interface';
import { UserNotification } from '../models/interfaces/user-notification.interface';
import { DeviceTypeEnum } from '../models/enum/device-type.enum';
import { SchoolDto } from '../models/dto/school.dto';
import {CalendarIntegrationUtil} from "../utils/calendar-integration-util";

@Injectable()
export class AuthIdentityService {
    constructor(
        private readonly cookieService: CookieService,
        private readonly usersService: UsersService,
        private readonly contractedFeatureService: ContractedFeatureService,
        private readonly integrationService: IntegrationService,
        private readonly userPreferenceService: UserPreferencesService,
        private readonly authUtil: AuthUtil,
        private readonly userUtil: UserUtil,
        private readonly contractedFeatureUtil: ContractedFeatureUtil,
        private readonly activesoftIntegrationUtil: ActivesoftIntegrationUtil,
        private readonly calendarIntegrationUtil: CalendarIntegrationUtil
    ) { }

    async fetchAndSaveData(identity: AuthIdentityResponse) {
        this.authUtil.saveTenant(identity.tenant);
        await this.fetchAndSaveUser(identity.tenantUserId);

        const user = this.userUtil.getUser();
        const school: SchoolDto = user.schools[0];
        const filter: ContractedFeatureFilterDto = {
            idUser: user.id,
            idSchool: school.id,
        };

        await this.fetchAndSaveContractedFeatures(filter);
        await this.fetchAndSaveIntegrations(school.id);

        this.addUserNotifications(identity.tenantUserId);
    }

    private async fetchAndSaveUser(userId: string): Promise<void> {
        try {
            const user = await this.usersService.getDetails(userId).toPromise();
            this.userUtil.addUser(user);

            if (user.preferences) {
                this.userPreferenceService.config(user.preferences);
            }
        } catch (error) {
            console.log(error);
            this.cookieService.deleteAll();
        }
    }

    private async fetchAndSaveContractedFeatures(filter: ContractedFeatureFilterDto) {
        try {
            const features = await this.contractedFeatureService
                .get(filter)
                .toPromise();
            this.contractedFeatureUtil.addFeatures(features);
        } catch (error) {
            console.log(error);
        }
    }

    private async fetchAndSaveIntegrations(idSchool: string) {
        try {
          const filter: IntegrationFilterDto = {
            idSchool: idSchool,
          };

          let integrations = await this.integrationService.get(filter).toPromise();

          if (integrations && integrations.length > 0) {
            const calendarIntegration = integrations.find(integration => integration.key === 'calendario');
            if (calendarIntegration) {
              this.calendarIntegrationUtil.setCalendar('yes');
            }

            const activesoftIntegration = integrations.find(integration => integration.key === 'activesoft');
            if (activesoftIntegration) {
              this.activesoftIntegrationUtil.setActivesoft('yes');
            }
          }


        } catch (error) {
            console.log(error);
        }
    }

    private addUserNotifications(id: string): void {
        const fcmToken = this.userUtil.getUserFcmToken();
        const userNotification: UserNotification = {
            deviceType: DeviceTypeEnum.WEB,
            fcmToken: fcmToken,
        };
        this.usersService.addUserNotificationV2(id, userNotification).subscribe(
            (res) => console.log(res),
            (err) => console.log(err)
        );
    }
}
